import { EventKind, Notification } from "@nova/schemas"

export const isMentionNotification = (notification: Notification) =>
    notification.kind === EventKind.CommentCreated &&
    notification.data.mentionedUserIds.includes(notification.recipientId)
